var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataset({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.781333 0.8204C-7.94729e-08 1.6401 0 2.9603 0 5.6V8.4C0 11.0397 -7.94729e-08 12.3599 0.781333 13.1796C1.56267 13.9993 2.81933 14 5.33333 14H6.66667C9.18067 14 10.438 14 11.2187 13.1796C11.9993 12.3592 12 11.0397 12 8.4V5.6C12 2.9603 12 1.6401 11.2187 0.8204C10.4373 0.000699949 9.18067 0 6.66667 0H5.33333C2.81933 0 1.562 -8.34465e-08 0.781333 0.8204ZM3.33333 5.075C3.20073 5.075 3.07355 5.13031 2.97978 5.22877C2.88601 5.32723 2.83333 5.46076 2.83333 5.6C2.83333 5.73924 2.88601 5.87277 2.97978 5.97123C3.07355 6.06969 3.20073 6.125 3.33333 6.125H8.66667C8.79928 6.125 8.92645 6.06969 9.02022 5.97123C9.11399 5.87277 9.16667 5.73924 9.16667 5.6C9.16667 5.46076 9.11399 5.32723 9.02022 5.22877C8.92645 5.13031 8.79928 5.075 8.66667 5.075H3.33333ZM3.33333 7.875C3.20073 7.875 3.07355 7.93031 2.97978 8.02877C2.88601 8.12723 2.83333 8.26076 2.83333 8.4C2.83333 8.53924 2.88601 8.67277 2.97978 8.77123C3.07355 8.86969 3.20073 8.925 3.33333 8.925H6.66667C6.79927 8.925 6.92645 8.86969 7.02022 8.77123C7.11399 8.67277 7.16667 8.53924 7.16667 8.4C7.16667 8.26076 7.11399 8.12723 7.02022 8.02877C6.92645 7.93031 6.79927 7.875 6.66667 7.875H3.33333Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataset);
export default __webpack_public_path__ + "static/media/Dataset.fb123fc89eab6c67cc1fe76bd47526e5.svg";
export { ForwardRef as ReactComponent };